<template>
  <el-dialog
      :visible.sync="isShow"
      width="800px"
      class="linkAllDialog"
      title="排行榜"
      :close-on-click-modal="false"
      top="12vh">

    <div style="display: flex">
      <el-date-picker v-model="recordYear" type="year"
                      placeholder="请选择年份"
                      class="yioks-w100"
                      value-format="yyyy"
                      :clearable = false
                      style="margin-bottom:20px;"
                      @change="changeQuery(true)"/>
    </div>

    <div class="sss" style="height: 530px;padding-bottom: 10px">
      <template>
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty" :whiteBg="true" style="height:500px;"></yioks-empty>
          <div v-else class="associatContetn"  style="height: 500px">
            <vue-scroll  :ops="ops">
              <template>
                <el-table :data="rankingList" style="width: 100%" show-summary :default-sort = "{prop: 'scoreSum', order: 'descending'}">
                  <el-table-column fixed type="index" label="排名" width="58px" align="center"></el-table-column>
                  <el-table-column fixed prop="youthShortName" label="机构名称" width="150px" align="center"></el-table-column>
                  <el-table-column fixed prop="matchScoreSum" label="高水平赛事积分" width="200px" align="center" sortable></el-table-column>
                  <el-table-column label="集训营积分" align="center">
                    <el-table-column prop="trainCampPlayerNumSum" label="人次" width="100px" align="center" sortable></el-table-column>
                    <el-table-column prop="trainCampScoreSum" label="积分" width="100px" align="center" sortable></el-table-column>
                  </el-table-column>
                  <el-table-column prop="scoreSum" label="总积分" width="150px" align="center" sortable ></el-table-column>
                </el-table>
              </template>
            </vue-scroll>

          </div>
        </template>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import storage from '@/utils/storage'
import { ops } from '@/utils/scrollIndialog'
import record from '@/api/record'
export default {
  name: 'index1',
  components: {
  },
  props: {
    isShowSumRankingDialog: {
      required: true,
      type: Boolean
    },
  },
  data () {
    return {
      ops,
      recordYear: "",
      uuid: storage.get('userInfo').uuid,
      userRole: storage.get('userInfo').userRole,
      rankingList: [],
      recordList: [],
      loading: true,
      empty: false,
    }
  },
  computed: {
    isShow: {
      get () {
        return this.isShowSumRankingDialog
      },
      set (val) {
        this.$emit('hideSumRankingDialog', val, false)
      }
    }
  },
  watch: {
    page(val) {
    }
  },
  created () {
    let year = new Date().getFullYear();
    this.recordYear = year.toString(); // 这个年份 默认是当前年
    this.getRecordAuditRanking() // 获取查询记录列表
  },
  methods: {
    changeQuery(flag) {
      this.getRecordAuditRanking()
    },

    // 查询机构排行榜
    getRecordAuditRanking () {
      record.getRecordSumAuditRanking(this.recordYear).then((res) => {
        if (res.code) {
          this.$message.error(res.msg)
        }else {
          this.loading = false
          this.empty = false
          this.rankingList = res
        }
      });
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.tutorial
  color #999
  font-size 16px
  .item
    padding 10px 0
    border-bottom 1px solid #CCC
    margin 0 20px
    .title
      padding 10px 0 25px 0
      font-size 20px
      font-weight bold
      color #000

.aaa
  color red !important
</style>
